import { useTranslation } from 'react-i18next';
import { AppLanguage } from '@anytag/shared-types';
import { cn, formatDate, localizedDateFormatter } from '@anytag/shared-utils';

interface DateProps {
  value?: string | null;
  className?: string;
}

export const Date = ({ value, className }: DateProps) => {
  const { i18n } = useTranslation();

  return (
    <div className={cn('text-left text-base whitespace-nowrap', className)}>
      {value ? (
        <>
          {localizedDateFormatter(value, 'MMM do', i18n.language as AppLanguage)}
          <br />
          <span className="text-xs text-tertiary">{formatDate(value, 'yyyy')}</span>
        </>
      ) : (
        '-'
      )}
    </div>
  );
};
